import React from 'react'

export default [
  {
    title: 'Email',
    dataIndex: 'recipientEmail',
    render: text => <a href={'mailto:' + text}>{text}</a>
  }, {
    title: 'State',
    dataIndex: 'state',
  }
]
